import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { StatusToast } from '@wix/design-system';
import StatusToastNotification from '@components/StatusToastNotification';

const ReviewUnavailableNotification: FC<{
  show: boolean;
  onClose: () => void;
  isMobileView: boolean;
}> = ({ show, onClose, isMobileView }) => {
  const { t } = useTranslation();

  return (
    <StatusToastNotification
      show={show}
      isMobileView={isMobileView}
      key="review-unavailable-notification"
      status="error"
      dismissible
      duration={8000}
      onDismiss={onClose}
      action={
        <StatusToast.Action onClick={onClose}>
          {t('marketplace.template-page.review.review-not-available.cta')}
        </StatusToast.Action>
      }
      message={t('marketplace.template-page.review.review-not-available.text')}
    />
  );
};

export default ReviewUnavailableNotification;
